import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { GeneralService } from '../services/general.service';
import { VerificacionPacienteService } from '../services/verificacion-paciente.service';
import { set } from 'date-fns';

@Component({
  selector: 'app-verificar-paciente',
  templateUrl: './verificar-paciente.component.html',
  styleUrls: ['./verificar-paciente.component.css']
})
export class VerificarPacienteComponent implements OnInit {

  public rutPacienteFind = new FormControl('', Validators.required);
  public submitted = false;
  public pacienteValid = 0;

  public cargando: boolean = false;


  constructor(
    public generalService: GeneralService,
    public verificacionDocumentosService: VerificacionPacienteService
  ) {}

  ngOnInit(): void {}

  onRutInput() {
    const rawValue = this.rutPacienteFind.value || '';

    // Elimina todo lo que no sea número o K/k, y reformatea
    const cleaned = rawValue.replace(/[^0-9kK]/g, '').toUpperCase();

    if (cleaned.length < 2) {
      this.rutPacienteFind.setValue(cleaned, { emitEvent: false });
      return;
    }

    const cuerpo = cleaned.slice(0, -1);
    const dv = cleaned.slice(-1);

    // Formatear el cuerpo (con puntos desde derecha hacia izquierda)
    const cuerpoFormateado = cuerpo
      .split('')
      .reverse()
      .join('')
      .match(/.{1,3}/g)
      ?.join('.')
      .split('')
      .reverse()
      .join('') || cuerpo;

    const formateado = `${cuerpoFormateado}-${dv}`;
    this.rutPacienteFind.setValue(formateado, { emitEvent: false });
  }

  verificarPaciente() {
    this.submitted = true;

    const rut = this.rutPacienteFind.value;

    if (!rut || !this.generalService.validaRutChileno(rut)) {
      console.warn('RUT inválido');
      this.rutPacienteFind.setErrors({ rutInvalido: true });
      return;
    }

    this.cargando = true; // Inicia el cargando

    this.verificacionDocumentosService.getVerificarPaciente({'rut': rut}).then((res: any) => {
      // console.log(res.datos);
      if(res.datos.status == true){
        // console.log('Correcto');
        this.pacienteValid = 1;
        this.cargando = false;
      }else{
        // console.log('Incorrecto');
        this.pacienteValid = 2;
        this.cargando = false;
      }

      setTimeout(() => {
        this.pacienteValid = 0;
        this.submitted = false;
        this.rutPacienteFind.setValue('');
      }, 10000);

    }).catch((error: any) => {
      console.log(error);
    });

  }


}
